import { Model } from './Model';

export const SizingRange = Model('SizingRange', { endpoint: 'apparel-sizing-ranges' })`
    id:Int;
    name:String;
`;
